/**
 * document-routes
 * com.ksoft
 *
 * OpenAPI spec version: 1.1
 * Contact: fposada@ksoftonline.co
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ArchivosService {

    protected basePath = 'http://localhost:8083/dr';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtener archivos de una solicitud
     * Retorna la lista de archivos vinculados a la solicitud indicada.
     * @param rid ID de la solicitud
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArchivosSolicitud(rid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getArchivosSolicitud(rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getArchivosSolicitud(rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getArchivosSolicitud(rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getArchivosSolicitud.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/archivos/solicitud`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener documentos anexos de una solicitud
     * Retorna la lista de documentos anexos vinculados a la solicitud indicada.
     * @param rid ID de la solicitud
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocumentosAnexos(rid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getDocumentosAnexos(rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getDocumentosAnexos(rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getDocumentosAnexos(rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getDocumentosAnexos.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/archivos/documentos-anexos`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ping(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public ping(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public ping(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public ping(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/archivos/ping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
